/**
 * Survive overlay ↔ embedded remounts (placement / md breakpoint / Sync open).
 * Cleared when the workspace ends (null) so unsent text does not leak into the
 * next session/patient — not only when the X button is used.
 */
let persistedComposerDraft = '';
let toastedCreatedKey: string | null = null;

export function getPersistedComposerDraft(): string {
  return persistedComposerDraft;
}

export function setPersistedComposerDraft(value: string): void {
  persistedComposerDraft = value;
}

export function getToastedCreatedKey(): string | null {
  return toastedCreatedKey;
}

export function setToastedCreatedKey(value: string | null): void {
  toastedCreatedKey = value;
}

export function clearPersistedVoiceWindowState(): void {
  persistedComposerDraft = '';
  toastedCreatedKey = null;
}

/** @internal Test helper — reset remount-survival globals between cases. */
export function resetVoiceWindowPersistStateForTests(): void {
  clearPersistedVoiceWindowState();
}
